import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild } from '@angular/core';
import { GridBodyCardRowTemplateDirective } from './card-row.template.directive';

@Directive({ selector: 'grid-body-card-row' })
export class GridBodyCardRowDirective {
  @Input() rowIndex!: number;
  @Input() row: any;

  // @Input()
  @ContentChild(GridBodyCardRowTemplateDirective, { read: TemplateRef })
  template!: TemplateRef<any>;
}
